import { render } from "./ButtonsWithBackgroudColor.vue?vue&type=template&id=a5f6e3f8"
import script from "./ButtonsWithBackgroudColor.vue?vue&type=script&lang=ts"
export * from "./ButtonsWithBackgroudColor.vue?vue&type=script&lang=ts"
script.render = render

export default script